import CloseIcon from '@mui/icons-material/Close'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material'

export interface ConfirmationModalProps {
  isOpen: boolean
  title: string
  subtitle?: string
  confirmText: string
  cancelText: string
  onConfirm: () => void
  onCancel: () => void
  loading?: boolean
}

export default function ConfirmationModal({
  isOpen,
  title,
  subtitle,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
  loading = false,
}: ConfirmationModalProps) {
  return (
    <Dialog open={isOpen} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="h6">{title}</Typography>
          <IconButton onClick={onCancel} size="small">
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>{subtitle}</DialogContent>
      <DialogActions>
        <Button
          onClick={onCancel}
          color="secondary"
          variant="outlined"
          disabled={loading}
        >
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          color="primary"
          variant="contained"
          loading={loading}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
